import React, { useState, useEffect } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import SbEditable from "storyblok-react"

import Image from "./../Image"
import ButtonPrimary from "../ButtonPrimary"
import BatchSmall from "../BatchSmall"

import styles from "./styles.module.scss"

const BlogGrid = (props) => {
  const [filterOptions, setFilterOptions] = useState([])
  const [currentFilter, setCurrentFilter] = useState("all")
  const [filteredItems, setFilteredItems] = useState([])

  const { blogPosts } = useStaticQuery(graphql`
    query {
      blogPosts: allStoryblokEntry(
        filter: { field_component: { eq: "blogpost" } }
        sort: { fields: field_date_string, order: DESC }
      ) {
        nodes {
          uuid
          slug
          full_slug
          content
        }
      }
    }
  `)

  const pushToArray = (arr, obj) => {
    const index = arr.findIndex((e) => e === obj)

    if (index === -1) {
      arr.push(obj)
    } else {
      arr[index] = obj
    }
  }

  useEffect(() => {
    let filterOptions = []

    blogPosts.nodes.forEach((post) => {
      let data = JSON.parse(post.content)

      if (Array.isArray(data.category)) {
        data.category.forEach((category) =>
          pushToArray(filterOptions, category)
        )
      } else {
        pushToArray(filterOptions, data.category)
      }
    })

    setFilterOptions(filterOptions)
  }, [])

  // Filter on click

  useEffect(() => {
    if (currentFilter == "all") {
      setFilteredItems(blogPosts.nodes)
    } else {
      let filteredPosts = blogPosts.nodes.filter((node) => {
        let data = JSON.parse(node.content)
        let categories = JSON.stringify(data.category)
        return categories.includes(currentFilter)
      })
      setFilteredItems(filteredPosts)
    }
  }, [currentFilter])

  const getCategory = (category) => {
    if (Array.isArray(category)) {
      return (
        <div className={styles["blog-grid__item-category-wrapper"]}>
          {category.map((cat, i) => (
            <span key={i} className={styles["blog-grid__item-category"]}>
              {cat}
            </span>
          ))}
        </div>
      )
    } else {
      return (
        <span className={styles["blog-grid__item-category"]}>{category}</span>
      )
    }
  }

  return (
    <SbEditable content={props.blok}>
      <section className={styles["blog-grid"]}>
        <div className="container">
          <ul className={styles["blog-grid__filter"]}>
            <li className={styles["blog-grid__filter-item"]}>
              <button
                className={`${currentFilter == "all" && "link"} button ${
                  styles["blog-grid__filter-button"]
                }`}
                onClick={() => setCurrentFilter("all")}
              >
                All
              </button>
            </li>
            {filterOptions &&
              filterOptions.length &&
              filterOptions.map((item, i) => {
                if (item == "") return

                return (
                  <li className={styles["blog-grid__filter-item"]} key={i}>
                    <button
                      className={`${currentFilter == item && "link"} button ${
                        styles["blog-grid__filter-button"]
                      }`}
                      onClick={() => setCurrentFilter(item)}
                    >
                      {item}
                    </button>
                  </li>
                )
              })}
          </ul>
          <ul className={styles["blog-grid__list"]}>
            {filteredItems.map((item, i) => {
              const slug = item.full_slug
              const blogContent = JSON.parse(item.content)

              console.log(slug)

              return (
                <li className={styles["blog-grid__item"]} key={i}>
                  <SbEditable content={props.blok}>
                    <article className={styles["blog-grid__item-article"]}>
                      <Link
                        to={`/${slug}`}
                        className={styles["blog-grid__item-inner"]}
                      >
                        <figure
                          className={styles["blog-grid__item-image-wrapper"]}
                        >
                          {blogContent.preview_image && (
                            <Image
                              blok={blogContent}
                              className={styles["blog-grid__item-image"]}
                              image={blogContent.preview_image}
                              params={{ maxWidth: 350 }}
                            />
                          )}
                          {blogContent.category != "" &&
                            getCategory(blogContent.category)}
                          {blogContent.one_million_thread && (
                            <div className={styles["blog-grid__item-batch"]}>
                              <BatchSmall />
                            </div>
                          )}
                        </figure>
                        <div className={styles["blog-grid__item-content"]}>
                          <h4
                            className={`heading-6 ${styles["blog-grid__item-heading"]}`}
                          >
                            <b>{blogContent.title}</b>
                          </h4>
                          <p
                            className={`body ${styles["blog-grid__item-text"]}`}
                          >
                            {blogContent.preview_text}
                          </p>
                          <ButtonPrimary
                            link={{
                              linktype: "inner",
                              cached_url: "/",
                            }}
                            label="Read article"
                            className={styles["blog-grid__item-button"]}
                          />
                        </div>
                      </Link>
                    </article>
                  </SbEditable>
                </li>
              )
            })}
          </ul>
        </div>
      </section>
    </SbEditable>
  )
}

export default BlogGrid
